import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getBlogPosts } from '../lib/microcms';

const CATEGORY_LABELS = {
  drip: 'ドリップ',
  beans: '豆の知識',
  gear: '器具・道具',
  recipe: 'レシピ',
  owner: '店主の話',
};

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'ブログ | GURI COFFEE';
    getBlogPosts()
      .then((data) => {
        setPosts(data.contents);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="gc-blog">
        <div className="gc-blog__container">
          <p className="gc-page__loading">読み込み中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gc-blog">
      <div className="gc-blog__container">
        <span className="gc-section-en">Blog</span>
        <h1 className="gc-section-title">コーヒーのある暮らし</h1>
        <p className="gc-blog__lead">
          淹れ方、豆の選び方、道具のこと。<br />
          日々のコーヒータイムがもっと豊かになるヒントをお届けします。
        </p>

        {posts.length === 0 ? (
          <p className="gc-blog__empty">記事の準備中です。</p>
        ) : (
          <div className="gc-blog__grid">
            {posts.map((post) => (
              <Link
                to={`/blog/${post.slug}`}
                key={post.id}
                className="gc-blog-card"
              >
                {post.eyecatch && (
                  <img
                    src={`${post.eyecatch.url}?w=600&h=400&fit=crop`}
                    alt={post.title}
                    className="gc-blog-card__img"
                    loading="lazy"
                  />
                )}
                <div className="gc-blog-card__body">
                  {post.category && post.category.length > 0 && (
                    <span className="gc-blog-card__cat">
                      {CATEGORY_LABELS[post.category] || post.category}
                    </span>
                  )}
                  <h2 className="gc-blog-card__title">{post.title}</h2>
                  <p className="gc-blog-card__desc">{post.description}</p>
                  <time className="gc-blog-card__date">
                    {new Date(post.publishedAt).toLocaleDateString('ja-JP')}
                  </time>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="gc-blog__cta-box">
          <p className="gc-blog__cta-text">
            コーヒーと人との向き合い方について、もっと深い話を書いています。
          </p>
          <div className="gc-blog__cta-links">
            <a href="https://note.com/guri4945" target="_blank" rel="noopener noreferrer" className="gc-blog__cta-link">
              note｜人と言葉を紡ぐ
            </a>
            <a href="https://substack.com/@guri4945" target="_blank" rel="noopener noreferrer" className="gc-blog__cta-link gc-blog__cta-link--sub">
              Substack｜ぐり
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogList;
